import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ingrainLogo from '../assets/images/clients/ingrain.png';
import khumarLogo from '../assets/images/clients/khumar.png';
import dostLogo from '../assets/images/clients/dost.jpg';

// Import client logos - add your client logo images to src/assets/images/clients/
// Example: import client1Logo from '../assets/images/clients/client1.png';

const About = () => {
  useEffect(() => {
    document.title = 'HexaCRM - About Us';
  }, []);
  // Client data - update with actual client logos and names
  const clients = [
    {
      id: 1,
      name: 'Ingrain',
      logo: ingrainLogo
    },
    {
      id: 2,
      name: 'Khumar Ceramics',
      logo: khumarLogo
    },
    {
      id: 3,
      name: 'Dost&Dost',
      logo: dostLogo
    },
    // {
    //   id: 4,
    //   name: 'Client Four',
    //   logo: 'https://via.placeholder.com/150x60?text=Client+4'
    // }
  ];

  return (
    <div>
      {/* Page Header */}
      <section className="page-header">
        <div className="container position-relative z-2">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1 className="display-3 text-white fw-bold">About Us</h1>
              <p className="lead hero-text">
                Learn more about our company, mission, and the team behind HexaCRM
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-lg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <span className="badge badge-primary mb-3">Our Story</span>
              <h2 className="display-5 fw-bold mb-4">Who We Are</h2>
              <p className="lead text-muted">
                HexaCRM is a leading provider of customer relationship management solutions,
                founded with a vision to transform how businesses interact with their customers.
              </p>
              <p className="lead text-muted">
                Our team consists of passionate professionals dedicated to delivering
                exceptional software solutions that help businesses grow and succeed in
                today's competitive marketplace. With over a decade of experience, we've
                helped thousands of companies streamline their operations.
              </p>
              <Link to="/services" className="btn btn-primary">
                Explore Our Services
              </Link>
            </div>
            <div className="col-lg-6">
              <div className="row">
                <div className="col-6">
                  <div className="card bg-gradient-primary text-white text-center p-4 mb-4">
                    <div className="display-3 fw-bold">5+</div>
                    <p className="mb-0">Years Experience</p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card bg-default text-white text-center p-4 mb-4 mt-4">
                    <div className="display-3 fw-bold">1K+</div>
                    <p className="mb-0">Happy Clients</p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card bg-default text-white text-center p-4">
                    <div className="display-3 fw-bold">30+</div>
                    <p className="mb-0">Team Members</p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card bg-gradient-primary text-white text-center p-4 mt-4">
                    <div className="display-3 fw-bold">99%</div>
                    <p className="mb-0">Satisfaction</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-lg bg-secondary">
        <div className="container">
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <h2 className="display-5 fw-bold">Our Mission & Vision</h2>
              <p className="lead text-muted">
                Guided by purpose, driven by innovation
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="card h-100 card-lift">
                <div className="card-body p-5">
                  <div className="icon icon-shape icon-shape-primary icon-lg mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                    </svg>
                  </div>
                  <h4 className="fw-bold">Our Mission</h4>
                  <p className="text-muted mb-0">
                    To empower businesses of all sizes with intuitive, powerful, and
                    affordable CRM solutions that drive growth, enhance customer relationships,
                    and streamline operations. We believe every business deserves access to
                    world-class tools.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="card h-100 card-lift">
                <div className="card-body p-5">
                  <div className="icon icon-shape icon-shape-success icon-lg mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                    </svg>
                  </div>
                  <h4 className="fw-bold">Our Vision</h4>
                  <p className="text-muted mb-0">
                    To become the global leader in CRM solutions, recognized for innovation,
                    reliability, and customer-centric approach. We envision a world where
                    every business can leverage technology to build meaningful, lasting
                    relationships with their customers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Clients */}
      <section className="py-lg">
        <div className="container">
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <h2 className="display-5 fw-bold">Our Clients</h2>
              <p className="lead text-muted">
                Trusted by leading companies across industries
              </p>
            </div>
          </div>
          <div className="row justify-content-center align-items-center">
            {clients.map((client) => (
              <div key={client.id} className="col-6 col-md-4 col-lg-3 mb-4">
                <div className="card card-lift h-100 text-center border-0">
                  <div className="card-body p-4 d-flex flex-column align-items-center justify-content-center">
                    <div className="client-logo mb-3">
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="img-fluid"
                        style={{ maxHeight: '60px', objectFit: 'contain' }}
                      />
                    </div>
                    <h6 className="fw-bold text-muted mb-0">{client.name}</h6>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {/* <section className="py-lg bg-gradient-primary">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="display-5 text-white fw-bold mb-4">
                Want to Join Our Team?
              </h2>
              <p className="lead hero-text mb-5">
                We're always looking for talented individuals who share our passion for
                innovation and customer success.
              </p>
              <a href="#" className="btn btn-white btn-lg">
                View Open Positions
              </a>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default About;
